module.exports = __webpack_public_path__ + "img/bg.ef04b535.png";